import type { EnvValueType } from '@hangar/shared';
import { FormField } from '@/components/FormField';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { OptionSelect } from '@/components/OptionSelect';
import { VALUE_TYPE_HELP } from './envHelpers';
import { VALUE_TYPES } from './envVarModel';
import type { EnvVarFormApi } from './useEnvVarForm';

/** Value type select and the config-time switch (never for secrets). */
export function EnvVarTypeConfig({ form }: { form: EnvVarFormApi }) {
  const { values, patch } = form;
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <FormField id="env-var-type" label="Type" hint={VALUE_TYPE_HELP[values.valueType]}>
        <OptionSelect
          id="env-var-type"
          data-testid="env-var-type"
          value={values.valueType}
          onValueChange={(v) => patch({ valueType: v as EnvValueType })}
          aria-describedby="env-var-type-hint"
          options={VALUE_TYPES.map((t) => ({ value: t, label: t }))}
        />
      </FormField>
      <div className="flex min-h-[74px] items-center justify-between gap-3 rounded-lg border bg-background px-3 py-2">
        <div className="min-w-0">
          <Label htmlFor="env-var-config-time" className="cursor-pointer text-[13px] font-medium">
            Also needed to read the app config
          </Label>
          <p className="text-xs text-subtle">Turn on when app.config.ts reads it (for example the app name or the project id). Never for secrets.</p>
        </div>
        <Switch id="env-var-config-time" data-testid="env-var-config-time" checked={values.configTime} disabled={values.visibility === 'secret'} onCheckedChange={(v) => patch({ configTime: v })} />
      </div>
    </div>
  );
}
